// src/index.js
import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { AuthProvider } from "./AuthProvider";
import { PermisosProvider } from "./context/PermisosContext";
import "./styles/index.css";

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <AuthProvider>
    <PermisosProvider>
      <App />
    </PermisosProvider>
  </AuthProvider>
);

console.log(`
    ░█████╗░██████╗░███╗░░░███╗  ░░░░░░  ██████╗░███╗░░░███╗███████╗  ░██████╗██████╗░░█████╗░██╗███╗░░██╗
    ██╔══██╗██╔══██╗████╗░████║  ░░░░░░  ██╔══██╗████╗░████║██╔════╝  ██╔════╝██╔══██╗██╔══██╗██║████╗░██║
    ██║░░╚═╝██████╔╝██╔████╔██║  █████╗  ██████╦╝██╔████╔██║█████╗░░  ╚█████╗░██████╔╝███████║██║██╔██╗██║
    ██║░░██╗██╔══██╗██║╚██╔╝██║  ╚════╝  ██╔══██╗██║╚██╔╝██║██╔══╝░░  ░╚═══██╗██╔═══╝░██╔══██║██║██║╚████║
    ╚█████╔╝██║░░██║██║░╚═╝░██║  ░░░░░░  ██████╦╝██║░╚═╝░██║███████╗  ██████╔╝██║░░░░░██║░░██║██║██║░╚███║
    ░╚════╝░╚═╝░░╚═╝╚═╝░░░░░╚═╝  ░░░░░░  ╚═════╝░╚═╝░░░░░╚═╝╚══════╝  ╚═════╝░╚═╝░░░░░╚═╝░░╚═╝╚═╝╚═╝░░╚══╝
`);